<template>
    <div class="o-page__inner"
        :data-component-name="$options.name"
    >
        <q-form class="o-form -sm" @submit.prevent="updateMyAccount(form)" ref="myAccountForm">
            <div class="o-page__loading" v-if="$apollo.loading">
                <q-spinner
                    color="white"
                    size="1em"
                />
                Chargement en cours
            </div>
            <fieldset class="o-form__inner" v-if="!$apollo.loading">
                <h1 class="o-form__title">Mon compte</h1>
                <div class="o-form__item">
                    <Input
                        v-model="form.name"
                        placeholder="Nom"
                        label="Nom"
                        required=true
                        error-message="Ce champ est requis"
                        :filled="false"
                        dense
                        :outlined="true"
                    />
                </div>
                <div class="o-form__item">
                    <Input
                        v-model="form.email"
                        placeholder="Email"
                        type="email"
                        label="Courriel"
                        required=true
                        error-message="Ce champ est requis"
                        :filled="false"
                        dense
                        :outlined="true"
                    />
                </div>
            </fieldset>
            <fieldset class="o-form__inner q-mt-md" v-if="!$apollo.loading && changePassword">
                <div class="o-form__item">
                    <input type="hidden" name="username" autocomplete="username email" :value="form.email">
                    <Input
                        v-model="form.currentPassword"
                        ref="currentPassword"
                        placeholder=""
                        autocomplete="current-password"
                        type="password"
                        label="Ancien mot de passe"
                        required=true
                        error-message="Ce champ est requis"
                        :filled="false"
                        dense
                        :outlined="true"
                    />
                </div>
                <div class="o-form__item">
                    <Input
                        v-model="form.newPassword"
                        ref="newPassword"
                        placeholder=""
                        type="password"
                        autocomplete="new-password"
                        label="Nouveau mot de passe"
                        required=true
                        :error="newPasswordValid"
                        :error-message="newPasswordValidMSG"
                        @input="newPassword=$event"
                        :filled="false"
                        dense
                        :outlined="true"
                    />
                </div>
                <div class="o-form__item">
                    <Input
                        v-model="form.newPasswordConfirm"
                        ref="newPasswordConfirm"
                        placeholder=""
                        autocomplete="new-password"
                        type="password"
                        label="Confirmer nouveau mot de passe"
                        required=true
                        :error="newPasswordConfirmValid"
                        error-message="Le mot de passe ne correspond pas au nouveau mot de passe"
                        @input="newPasswordConfirmValid=isSame($event, 'newPassword')"
                        :filled="false"
                        dense
                        :outlined="true"
                    />
                </div>
            </fieldset>
            <fieldset class="o-form__inner" v-if="!$apollo.loading">
                <div class="o-form__item" v-if="!changePassword">
                    <small><a href="#" @click.prevent="changePassword=true">Changer mon mot de passe</a></small>
                </div>
                <div class="o-form__item" v-if="changePassword">
                    <small><a href="#" @click.prevent="changePassword=false">Annuler changer mon mot de passe</a></small>
                </div>
                <div class="o-form__item -button">
                    <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary">
                        Sauvegarder
                        <q-icon name="save" class="o-ico -right" />    
                    </button>
                </div>
            </fieldset>
        </q-form>

        <q-dialog v-model="alert" persistent>
            <q-card>
                <q-card-section>
                <div class="text-h6">Attention</div>
                </q-card-section>

                <q-card-section class="q-pt-none">
                    Votre mot de passe a été changé. Vous serez déconnecté automatiquement d'ici 5 secondes ou <router-link :to="{ name: 'logout'}">cliquez ici</router-link> pour continuer.
                </q-card-section>

            </q-card>
        </q-dialog>

    </div>
</template>


<script>
    import { ME } from "@/graphql/auth/queries";
    import { updateMyAccount } from '@/graphql/user/mutations'

    export default {
        name: 'myAccount',
        apollo: {
            me: {
                query: ME,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(me){
                    this.form = Object.assign({}, me.me);
                    return me
                }
            }
        },
        data(){
            return {
                form: null,
                changePassword: false,
                newPassword: null,
                newPasswordValid: false,
                newPasswordValidMSG: 'Ce champ est requis',
                newPasswordConfirmValid: false,
                alert: false 
            }
        },
        computed: {
        },
        watch: {
            changePassword: function(){
                if(!this.changePassword){
                    delete this.form.currentPassword
                    delete this.form.newPassword
                    delete this.form.newPasswordConfirm
                }
            },
            newPassword: function(){
                // if(!this.newPassword) return false;
                let complexityError=false;
                this.newPasswordValid=false;

                if(!this.newPassword || this.newPassword==""){
                    this.newPasswordValid=true;
                    this.newPasswordValidMSG="Ce champ est requis.";
                    return;
                }
                if(this.newPassword==this.form.currentPassword){
                    this.newPasswordValid=true;
                    this.newPasswordValidMSG="Le nouveau mot de passe doit être différent du mot de passe précédent.";
                    return;
                }

                if( this.newPassword.length < 8 ){
                    complexityError=true;
                } 
                if( ! /\d/.test(this.newPassword) ){
                    complexityError=true;
                } 
                if( ! /[a-z]/.test(this.newPassword) ){
                    complexityError=true;
                } 
                if( ! /[A-Z]/.test(this.newPassword) ){
                    complexityError=true;
                } 
                if( ! /[!@#$%^&*)(+=._-]/.test(this.newPassword) ) complexityError=true;

                if(complexityError){
                    this.newPasswordValid=true;
                    this.newPasswordValidMSG="Le nouveau mot de passe doit contenir au minimum 8 caractères et au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial.";
                }
            }
        },
        methods: {
            isDifferent(needle, haystack){
                if(needle=='' || !this.$refs[haystack]) return false;
                return needle == this.$refs[haystack].value
            },
            isSame(needle, haystack){
                if(needle=='' || !this.$refs[haystack]) return false;
                return needle != this.$refs[haystack].value
            },
            async updateMyAccount(updateMyAccountDetails){
                let validation=await this.$refs.myAccountForm.validate()
                if(!validation){
                    this.$q.notify({type: 'negative', message: "Informations non savegardées", caption: "Certains champs n'ont pas été remplis correctement."});
                    return false;
                }
                Object.keys(this.$refs).forEach(function (ref) {
                    if(this.$refs[ref]?.$attrs.error){
                        validation=false
                        return false;
                    }
                }.bind(this));
                
                if(!validation){
                    this.$q.notify({type: 'negative', message: "Informations non savegardées", caption: "Certains champs n'ont pas été remplis correctement."});
                    return false;
                }

                this.$apollo.mutate({
                    mutation: updateMyAccount,
                    variables: { ...updateMyAccountDetails }
                }).then(() => {
                    this.$q.notify({type: 'positive', message: "Compte : "+updateMyAccountDetails.name, caption: "Informations sauvegardées"})
                    if(updateMyAccountDetails.newPassword){
                        this.alert=true;
                        setTimeout(function(){
                        	this.$router.push('/logout')
                        }.bind(this), 5000)
                    }
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                }).finally(() => {
                })
            },
        }
    }
</script>
<style lang="scss">
    .o-form__item .q-field--error .q-field__bottom--animated {
        display:block;
        position:relative;
        transform: none;
    }
</style>
